import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LinearProgress, Typography, linearProgressClasses, useTheme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { round } from "../utils/numbers";
const useStyles = makeStyles((theme) => createStyles({
    fatProgressContainer: {
        width: 90,
        gridTemplateRows: "16px",
        gridTemplateColumns: "30px 30px 30px",
        paddingLeft: theme.spacing(2),
        display: "grid",
    },
    fatProgressLabel: {
        zIndex: 1000,
        gridRowStart: 1,
        gridColumnStart: 2,
        paddingLeft: theme.spacing(),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    root: {
        height: "inherit",
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
}));
export const FatProgressBar = ({ current, target, unit, usePercent = false, error = false }) => {
    const { palette: { info }, } = useTheme();
    const value = (100 * current) / target;
    const classes = useStyles();
    return (_jsxs("div", { className: classes.fatProgressContainer, children: [_jsx(LinearProgress, { sx: {
                    height: "inherit",
                    borderRadius: "3px",
                    gridRowStart: 1,
                    gridColumnStart: 1,
                    gridColumnEnd: 4,
                    [`&.${linearProgressClasses.colorPrimary}`]: {
                        backgroundColor: info.lighter,
                    },
                    [`& .${linearProgressClasses.bar}`]: {
                        backgroundColor: info.light,
                    },
                }, variant: "determinate", value: Math.min(100, value) }), _jsx("div", { className: classes.fatProgressLabel, children: _jsx(Typography, { variant: "subtitle1", children: usePercent ? `${round(value, 0)}%` : `${current}/${target}${unit}` }) })] }));
};
//# sourceMappingURL=FatProgressBar.js.map